export default __webpack_public_path__ + "static/media/footermlogo.deb3d370.svg";